import React from 'react';

import { VpTablePagination } from '../..';
import { useFetchVideoCompilations } from '../../../hooks';

export const VpVideoCompilationsTablePagination = () => {
  const { data } = useFetchVideoCompilations();
  const meta = data?.recordMetadata;

  return <VpTablePagination data={meta} />;
};

export default VpVideoCompilationsTablePagination;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpVideoCompilationTable/VpVideoCompilationsTablePagination.jsx